import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/Footer/Footer.container';
import { setFooterRef } from 'Store/Ui/Ui.action';
import { DeviceType } from 'Type/Device.type';

import Footer from './Footer.component';
/** @namespace Bodypwa/Component/Footer/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    headerHeight: state.UiReducer.headerHeight,
    header_logo_src: state.ConfigReducer.header_logo_src,
    logo_alt: state.ConfigReducer.logo_alt,
    logo_height: state.ConfigReducer.logo_height,
    logo_width: state.ConfigReducer.logo_width,
    isCheckout: state.CheckoutReducer.isCheckout,
    footerColumns: state.ConfigReducer.footer_section_links,
    paymentCardsColumns: state.ConfigReducer.footer_section_payment_icons
});

/** @namespace Bodypwa/Component/Footer/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    setFooterRef: (ref) => dispatch(setFooterRef(ref))
    // TODO extend mapDispatchToProps
});
/** @namespace Bodypwa/Component/Footer/Container */
export class FooterContainer extends PureComponent {
    static propTypes = {
        copyright: PropTypes.string.isRequired,
        // eslint-disable-next-line react/boolean-prop-naming
        newsletterActive: PropTypes.bool.isRequired,
        device: DeviceType.isRequired,
        header_logo_src: PropTypes.string.isRequired,
        logo_alt: PropTypes.string.isRequired,
        logo_heigh: PropTypes.string,
        logo_width: PropTypes.string,
        isCheckout: PropTypes.bool.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        footerColumns: PropTypes.array,
        // eslint-disable-next-line react/forbid-prop-types
        paymentCardsColumns: PropTypes.array,
        setFooterRef: PropTypes.func.isRequired
    };

    static defaultProps = {
        footerColumns: [],
        paymentCardsColumns: {},
        logo_width: 'auto',
        logo_heigh: 'auto'
    };

    footerRef = createRef();

    componentDidUpdate() {
        const { setFooterRef } = this.props;
        if (this.footerRef && this.footerRef.current) {
            setFooterRef(this.footerRef);
        }
    }

    containerProps() {
        const {
            copyright,
            device,
            newsletterActive,
            header_logo_src,
            logo_alt,
            logo_heigh,
            logo_width,
            isCheckout,
            footerColumns,
            paymentCardsColumns
        } = this.props;

        return {
            copyright,
            device,
            newsletterActive,
            header_logo_src,
            logo_alt,
            logo_heigh,
            logo_width,
            isCheckout,
            footerColumns,
            paymentCardsColumns,
            footerRef: this.footerRef
        };
    }

    render() {
        return (
            <Footer
              { ...this.containerProps() }
            />
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
